import React, {PropTypes as T} from 'react';
import GAPriceCategory from '../gapricecategory';
import pricesForSection from '../../../../utils/sim/prices_for_section';

export default class GASelection extends React.Component {
  static propTypes = {
    section: T.object,
    event:   T.object,
    basket:  T.object,
    totalQuantityInSelection: T.number,
    totalQuantityInSection: T.number
  };

  render () {
    const {section, basket, totalQuantityInSelection, totalQuantityInSection} = this.props;

    // only render this module if its a valid section and is a GA section or we're in seatmap overview mode
    if (!section || !(section.isGA || basket.config.seatmapDisplayOverviewMode)) {
      return false;
    }

    const sortedPrices = pricesForSection(section, basket.priceTypes, basket.prices);

    return (
      <div>
        {
          section.priceCategories.map(
            (priceCatId, index) => {
              const prices = sortedPrices.filter(price => price.priceCategory === priceCatId);

              return <GAPriceCategory
                key={`${priceCatId}-${index}`}
                basket={basket}
                priceCategory={basket.priceCategories[priceCatId]}
                priceCategoryAvailability={section.priceCategoryAvailability}
                prices={prices}
                totalQuantityInSelection={totalQuantityInSelection}
                totalQuantityInSection={totalQuantityInSection} />;
            }
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/generaladmission/gaselection/index.js